// This is a minimal JavaScript file to enhance the form with interactive features
// All core functionality works with CSS only, this is just for extra user experience

document.addEventListener('DOMContentLoaded', function() {
  // Update progress bar as user navigates through form
  const stepControls = document.querySelectorAll('.step-control');
  const progressFill = document.getElementById('progress-fill');
  const stepIndicators = document.querySelectorAll('.step');
  
  stepControls.forEach((control, index) => {
    control.addEventListener('change', function() {
      // Update progress bar
      const progress = ((index + 1) / (stepControls.length)) * 100;
      progressFill.style.width = `${progress}%`;
      
      // Update step indicators
      stepIndicators.forEach((step, stepIndex) => {
        if (stepIndex === index) {
          step.classList.add('active');
        } else {
          step.classList.remove('active');
        }
      });
    });
  });
  
  // Toggle password visibility
  const togglePassword = document.querySelector('.toggle-password');
  const passwordInput = document.getElementById('password');
  
  if (togglePassword && passwordInput) {
    togglePassword.addEventListener('click', function() {
      const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
      passwordInput.setAttribute('type', type);
      
      // Update eye icon
      const eyeIcon = this.querySelector('.eye-icon');
      if (type === 'password') {
        eyeIcon.style.backgroundImage = "url(\"data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z' stroke='%23767676' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z' stroke='%23767676' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";
      } else {
        eyeIcon.style.backgroundImage = "url(\"data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99836 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88' stroke='%23767676' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1 1L23 23' stroke='%23767676' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";
      }
    });
  }
  
  // Basic form validation
  const form = document.getElementById('registration-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      // In a real application, you would add actual form validation here
      // For this demo, we're using HTML5 validation and just preventing the default submit
    });
  }
  
  // Initialize with first step active
  stepIndicators[0].classList.add('active');
});